// extracted by mini-css-extract-plugin
export var chevronIcon = "_9w-2";
export var teamName = "_9w-1";
export var teamSwitcherButton = "_9w-0";